<template>
	<div v-if="category && features">
		<div v-for="item in features" :key="item.id" class="ty-flex mt-3">
				<div  style="min-width: 80px" class="ty-flex white-space-nowrap my-auto">{{item.filter.name}} =</div>
				<feature-value :key="item.id" class="mr-4" v-model="item.value" :feature-type="item.filter" @change="update" @input="update" @upadte="update"/>
		</div>
	</div>
	<div v-else>
		برای ویرایش ویژگی ها باید ابتدا دسته بندی این محصول را انتخاب کنید.
	</div>
</template>

<script>
	import FeatureValue from './FeatureValue'
	export default {
		props: {
			value: {
				type: Array,
				default: () => []
			},
			productId: {
				type: String,
				required: true
			},
			groupId: {
				type: String,
				default: null
			},
			// filters: {
			// 	type: Array,
			// 	default: () => []
			// },
			category: {
				type: Object,
				default: () => null
			}
		},
		components: {
			'feature-value': FeatureValue
		},
		data() {
			const {
				value,
				groupId
			} = this;
			return {
				test: '',
				features: null,
				productFeatures: value.filter((feature) => {return feature.group_id == groupId}),
				content: null,
				types: {
					0: 'text',
					1: 'select',
					2: 'image',
					3: 'color',
					4: 'boolean',
					5: 'number',
				},
				CategoryFilterType: [{
						label: 'متن',
						value: 0
					},
					{
						label: 'انتخاب',
						value: 1
					},
					{
						label: 'تصویر',
						value: 2
					},
					{
						label: 'رنگ',
						value: 3
					},
					{
						label: 'دارا بودن',
						value: 4
					},
					{
						label: 'عدد',
						value: 5
					}
				]
			}
		},
		methods: {
			handleDelete(i) {
				const filter = this.features[i];
				if (!filter.id) this.features.splice(i, 1);
			},
			handleEdit(i) {
				this.features[i].edit = true;
			},
			getFeatures () {
				this.features = (this.category?.filters??[]).map(filter => {
					const j = this.productFeatures.findIndex(feature => feature.filter_id===filter.id)
					if (j !== -1) {
						return {
							filter,
							filter_id: filter.id,
							product_id: this.productId,
							value: this.productFeatures[j][filter.type]
						}
					} else {
						return {
							filter,
							filter_id: filter.id,
							product_id: this.productId,
							value: null
						}
					}
				}).filter((feature) => {return feature.group_id==this.groupId});
			},
			update() {
				this.$emit('input', this.features);
				this.$emit('change');
				this.$emit('update');
			}
		},
		mounted() {
			this.getFeatures()
		}
	}
</script>